<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Projects
                                Record</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-row class="py-2">

                                    <v-col md="4" cols="12">
                                        <v-text-field v-model="search" append-inner-icon="mdi-magnify" label="Search"
                                            single-line hide-details density="compact" variant="outlined"
                                            bg-color="grey-lighten-4" class="pl-2" clearable></v-text-field>
                                    </v-col>

                                    <v-col md="5" cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                                                <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success"
                                                    @click="exportToCSV">CSV</v-btn>
                                                <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary"
                                                    @click="exportToExcel">EXCEL</v-btn>
                                                <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red"
                                                    @click="exportToPDF">PDF</v-btn>
                                            </v-btn-group>
                                        </div>
                                    </v-col>

                                    <v-col md="3" cols="12">
                                        <div class="text-right pr-2">
                                            <v-btn v-if="$insertAccess($route.fullPath)"
                                                @click="goTo('/project/add-project')" color="primary" variant="tonal"
                                                prepend-icon="mdi mdi-plus" rounded="xl">
                                                Add Project
                                            </v-btn>
                                        </div>
                                    </v-col>

                                </v-row>

                                <v-data-table :headers="headers" :items="getSchema" :loading="loading"
                                    v-model:items-per-page="itemsPerPage" :search="search" :hover="true"
                                    density="compact">

                                    <template v-slot:item.index="{ index }">
                                        {{ ++index }}
                                    </template>

                                     <template v-slot:item.project_title="{ item }">
                                        <span>
                                          {{ (item.project_title || '').length > 300 ? item.project_title.slice(0, 50) + '...' : item.project_title }}
                                        </span>
                                    </template>
                                    
                                    <template v-slot:item.code="{ item }">
                                        <router-link :to="{ name: 'project-detail', params: { id: item.id } }" target="_blank" class="text-primary">
                                            {{ item.code }}
                                        </router-link>
                                    </template>

                                     <template v-slot:item.progress="{ item }">
                                            <v-progress-circular
                                                :model-value="Math.abs(item.progress)"
                                                size="60"
                                                width="5"
                                                :color="item.progress >= 0 ? 'green-darken-2' : 'red-darken-2'"
                                                bg-color="grey-lighten-3"
                                            >
                                                <span class="text-body-2 font-weight-bold">
                                                {{ item.progress }}%
                                                </span>
                                            </v-progress-circular>
                                    </template>

                                    <template v-slot:item.registration_type="{ item }">
                                         <v-chip v-if="item.registration_type == '1'" color="warning" size="small" class="text-capitalize">
                                            {{ item.registration_type == '1' ? 'Open' : item.registration_type == '2' ? 'Ongoing' : 'Closed' }}
                                         </v-chip>
                                         <v-chip v-else-if="item.registration_type == '2'" color="secondary" size="small" class="text-capitalize">
                                            {{ item.registration_type == '1' ? 'Open' : item.registration_type == '2' ? 'Ongoing' : 'Closed' }}
                                         </v-chip>
                                         <v-chip v-else color="red" size="small" class="text-capitalize">
                                            {{ item.registration_type == '1' ? 'Open' : item.registration_type == '2' ? 'Ongoing' : 'Closed' }}
                                         </v-chip>
                                    </template>

                                    <template v-slot:item.status="{ item }">
                                        <v-chip v-if="item.status == 1" color="success" size="small"
                                            class="text-capitalize">Active</v-chip>
                                        <v-chip v-else color="red" size="small"
                                            class="text-capitalize">Inactive</v-chip>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                          <v-icon
                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="viewProject(item)"
                                                >
                                                mdi mdi-eye
                                            </v-icon>

                                        <v-icon class="me-2 edit-button" color="primary" @click="editItem(item)"
                                            v-if="$updateAccess($route.fullPath)">
                                            mdi mdi-pencil-outline
                                        </v-icon>
                                        <v-icon class="me-2 edit-button" color="red" @click="deleteItem(item)"
                                            v-if="$updateAccess($route.fullPath)">
                                            mdi mdi-delete-outline
                                        </v-icon>
                                    </template>

                                </v-data-table>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import Axios from 'axios';
import { deleteProject } from '@/store/api';
import { toast } from "vue3-toastify";

export default {
    components: {

    },
    data: () => ({
        itemsPerPage: 50,
        panel: [0],
        loading: false,
        search: "",
        dialog: false,
        data: {},
        headers: [
            { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
            { title: "Project Number", key: "code", align: "left", sortable: false },
            // { title: "Project Name", key: "name", align: "left", sortable: false },
            { title: "Project Title", key: "project_title", align: "left", sortable: false },
            // { title: "Point of Contact", key: "contacted_by.name", align: "left", sortable: false },
            { title: "Customer", key: "customer.name", align: "left", sortable: false },
            { title: "Amount", key: "amount", align: "left", sortable: false },
            { title: "Paid", key: "paid_amount", align: "left", sortable: false },
            { title: "Due", key: "due_amount", align: "left", sortable: false },
            { title: "Project Status", key: "registration_type", align: "left", sortable: false },
            { title: "Start Date", key: "start_date", align: "left", sortable: false },
            { title: "End Date", key: "end_date", align: "left", sortable: false },
            { title: "Progress", key: "progress", align: "left", sortable: false },
            { title: "Status", align: "center", key: "status", sortable: true },
            { title: "Actions", align: "center", key: "actions", sortable: false }
        ],
    }),
    watch: {
    },
    created() {
        if (this.$store.getters.getProjectList.length == 0) {
            this.loading = true;
            this.$store.dispatch('getProjectList').then((response) => {
                this.loading = false;
            })
        };
    },
    computed: {
        getSchema() {
            return this.$store.getters.getProjectList;
        },
    },
    methods: {
        goTo(val){
            this.$router.push({path: val}).catch((err) => {});
        },
        editItem(item) {
            this.$store.commit('setEditingProject', item);
            this.$router.push({ path: "add-project", query: { id: item.id } });
        },
        deleteItem(item) {
            if (confirm('Are you sure you want to delete this full project?')) {

                Axios.get(deleteProject+'/'+item.id).then(response => {
                    toast.success(response.data.message);

                    this.$store.dispatch("getProjectList").then((data) => {
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                        console.error("Error:", error);
                        toast.error(error.response?.data?.message || "An error occurred");
                    });
                })
                .catch((error) => {
                    console.error("Error:", error);
                    toast.error(error.response?.data?.message || "An error occurred");
                });
            }
        },
        linkProject(item) {
            this.$router.push({
                name: "project-detail",
                params: { id: item.id },
            });
        },
        viewProject(item) {
            this.$store.commit("setEditingProject", item);
            // const routeUrl = this.$router.resolve({
            //     name: "project-detail",
            //     params: { id: item.id },
            // }).href;
            // window.open(routeUrl, "_blank");
                this.$router.push({
                    name: "project-detail",
                    params: { id: item.id },
                });
            },
        exportToPDF() {
            let serialNumber = 1;
            const columns = ['#SL', 'Project Number', 'Project Title', 'Point Of Contact', 'Amount', 'Paid', 'Due', 'reg.', 'Start Date', 'End Date', 'Status'];
            const rows = this.getSchema.map(item => [serialNumber++, item.code, item.project_title, item.contacted_by.name, item.agreed_amount, item.paid_amount, item.due_amount, item.registration_type == 1 ? 'Open' : item.registration_type == 2 ? 'Ongoing' : 'Closed', item.start_date, item.end_date, item.status == 1 ? 'Active' : 'Inactive']);
            this.$exportTableToPDF(columns, rows, 'Projects List', 'projects_list_' + this.$fileDate())
        },
        exportToExcel() {
            var data = [['#SL', 'Project Number', 'Project Title', 'Point Of Contact', 'Amount', 'Paid', 'Due', 'reg.', 'Start Date', 'End Date','Status']];
            var serialNumber = 1;
            this.getSchema.forEach(item => {
                data.push([serialNumber++, item.code, item.project_title, item.contacted_by.name, item.agreed_amount, item.paid_amount, item.due_amount, item.registration_type == 1 ? 'Open' : item.registration_type == 2 ? 'Ongoing' : 'Closed', item.start_date, item.end_date, item.status == 1 ? 'Active' : 'Inactive']);
            });
            this.$exportTableToExcel(data, 'projects_list_' + this.$fileDate());
        },
        exportToCSV() {
            var data = [['#SL', 'Project Number', 'Project Title', 'Point Of Contact', 'Amount', 'Paid', 'Due', 'reg.', 'Start Date', 'End Date','Status']];
            var serialNumber = 1;
            this.getSchema.forEach(item => {
                data.push([serialNumber++, item.code, item.project_title, item.contacted_by.name, item.agreed_amount, item.paid_amount, item.due_amount, item.registration_type == 1 ? 'Open' : item.registration_type == 2 ? 'Ongoing' : 'Closed', item.start_date, item.end_date, item.status == 1 ? 'Active' : 'Inactive']);
            });

            this.$exportTableToCSV(data, 'projects_list_' + this.$fileDate());
        },
    },
    mounted() {

    }
}
</script>